(function($) {
    'use strict';

    $.fn.staffPopup = function () {
        const $self = $(this);
        const $template = $($self.find('.hidden').first().contents());

        const init = function () {
            $self.on('click', function (e) {
                e.preventDefault();

                $.magnificPopup.open({
                    items: {
                        src: $template.clone(),
                        type: 'inline'
                    },
                    mainClass: 'popup--staff',
                    preloader: false,
                    closeOnBgClick: true,
                    callbacks: {
                        open: function() {
                            SVK.makeFixedHtml();
                        },
                        close: function() {
                            SVK.makeUnfixedHtml();
                        }
                    }
                });
            });

        };

        init();

        return this;
    };

    document.addEventListener('DOMContentLoaded', function () {
        $('.js-staff-list-item').each(function () {
            $(this).staffPopup();
        });
    });
})(jQuery);
